<div class="container-xxl mx-0 pb-4">
    <p class="text-secondary mb-4">
        {{ 'quickexports_export_quick_description' | translate: 'online' : 'export' }}
    </p>

    <app-step-flow
        headingKey="quickexports_export_tab_quick_exports"
        [steps]="steps()"
        [statuses]="quickExportFormService.stepStatuses()">
        <div class="d-flex justify-content-end align-items-center gap-3">
            @if (isSpecificDateMode()) {
                <app-action-button
                    [label]="
                        quickExportFormService.isExporting()
                            ? {key: 'quickexports_export_action_exporting', module: 'export'}
                            : {key: 'actions_export', module: 'systems'}
                    "
                    icon="bi-download"
                    [busy]="quickExportFormService.isExporting()"
                    [disabled]="quickExportFormService.isExportDisabled()"
                    (run)="quickExportFormService.export()" />
            } @else {
                <span class="form-text m-0">
                    {{ 'savedexport_will_appear_hint' | translate: 'online' : 'export' }}
                </span>
                <app-export-test-button />
                <app-action-button
                    [label]="{key: 'savedexport_save_schedule', module: 'export'}"
                    icon="bi-calendar-event"
                    [busy]="quickExportFormService.isSaving()"
                    [disabled]="quickExportFormService.isSaving()"
                    (run)="quickExportFormService.saveSchedule()" />
            }
        </div>
    </app-step-flow>
</div>
